module.exports = __webpack_public_path__ + "img/more-arrow-down.07d1464d.svg";